const SEEDED_DEMO_SITE_IDS = new Set([
  '44444444-4444-4444-4444-444444444401',
  '44444444-4444-4444-4444-444444444402',
  '44444444-4444-4444-4444-444444444403',
]);

const SEEDED_DEMO_SSU_IDS = new Set([
  '33333333-3333-3333-3333-333333333301',
  '33333333-3333-3333-3333-333333333302',
  '33333333-3333-3333-3333-333333333303',
]);

export function withoutSeededDemoSsus<T extends { id: string }>(
  ssus: readonly T[],
  hideSeededData = shouldHideSeededData(),
): T[] {
  if (!hideSeededData) return [...ssus];
  return ssus.filter((ssu) => !SEEDED_DEMO_SSU_IDS.has(ssu.id));
}

export function withoutSeededDemoSites<T extends { id: string }>(
  sites: readonly T[],
  hideSeededData = shouldHideSeededData(),
): T[] {
  if (!hideSeededData) return [...sites];
  return sites.filter((site) => !SEEDED_DEMO_SITE_IDS.has(site.id));
}

export function withoutSeededDemoCameras<T extends { siteId: string }>(
  cameras: readonly T[],
  hideSeededData = shouldHideSeededData(),
): T[] {
  if (!hideSeededData) return [...cameras];
  return cameras.filter((camera) => !SEEDED_DEMO_SITE_IDS.has(camera.siteId));
}

function shouldHideSeededData(): boolean {
  return import.meta.env.PROD && import.meta.env.MODE !== 'demo';
}
